module.exports = __webpack_public_path__ + "static/media/-_dashboard.ad474442.svg";